import './site.scss';

import Rellax from 'rellax';
import inView from 'in-view';
import Notify from 'simple-notify';
import { registerAnalytics } from './js/analytics';

registerAnalytics();

// Инициализация либы параллакса

const initRellax = () => {
    if ([...document.querySelectorAll('.rellax')].length === 0) return;
    const rellax = new Rellax('.rellax', {
        center: true
    });

    rellax.refresh();
};

// Инициализация либы появления элементов

const initInView = () => {
    if (!document.querySelector('.in-view')) return;

    inView('.in-view').on('enter', (e) => {
        e.classList.remove('hide');
    });
};

// Анимация аккордеонов

class Accordion {
    constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="content"> element
        this.content = el.querySelector('.accordion-item__content');

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    }

    shrink() {
        // Set the element as "being closed"
        this.isClosing = true;
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate(
            {
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            },
            {
                duration: 800,
                easing: 'cubic-bezier(0.27, 0.48, 0, 1.02)'
            }
        );

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => {
            this.isClosing = false;
        };
    }

    open() {
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        this.el.dataset.expanded = true;
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${
            this.summary.offsetHeight + this.content.offsetHeight
        }px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate(
            {
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            },
            {
                duration: 800,
                easing: 'cubic-bezier(0.27, 0.48, 0, 1.02)'
            }
        );
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => {
            this.isExpanding = false;
        };
    }

    onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.el.style.height = '';
        this.el.style.overflow = '';
    }
}

document.querySelectorAll('.details').forEach((el) => {
    new Accordion(el);
});

// Убирать подкладку под шапку при начале скролла
const header = document.querySelector('.header');
const headerChecker = document.querySelector('.header-checker');

if (header) {
    inView('.header-checker')
        .on('enter', () => {
            header.classList.add('clear');
        })
        .on('exit', () => {
            header.classList.remove('clear');
        });
}

const checkHeaderPos = () => {
    if (headerChecker) {
        if (!inView.is(headerChecker)) {
            header.classList.remove('clear');
        }
    }
};

// Инициализируем модальное окно

const initModal = () => {
    const modals = [...document.querySelectorAll('.dialog')];
    const closeBtns = [...document.querySelectorAll('.dialog__close-button')];
    const openBtns = [...document.querySelectorAll('.modal-link')];

    if (!openBtns.length && !modals.length) return;

    function open(event) {
        event.preventDefault();
        document
            .querySelector(`.dialog[data-name='${this.dataset.name}']`)
            .showModal();
    }

    function close(event) {
        event.preventDefault();
        document
            .querySelector(`.dialog[data-name='${this.dataset.name}']`)
            .close('Ok! 🤠');
    }

    function isClickedInDialog(event) {
        const rect = event.target.getBoundingClientRect();

        return rect.top <= event.clientY
            && event.clientY <= rect.top + rect.height
            && rect.left <= event.clientX
            && event.clientX <= rect.left + rect.width;
    }

    function isDialogCanClose(modal) {
        return modal.firstElementChild.classList.contains('dialog__close-button');
    }

    function handlerDialogClick(event) {
        if (event.target.tagName !== 'DIALOG') return;
        if (isClickedInDialog(event) === false) close.call(event.target, event);
    }

    modals.forEach((modal) => {

        if (isDialogCanClose(modal)) {
            modal.addEventListener('click', handlerDialogClick);
        } else {
            modal.addEventListener('cancel', (event) => event.preventDefault());
        }
    });

    openBtns.forEach((openBtn) => openBtn.addEventListener('click', open.bind(openBtn)));
    closeBtns.forEach((closeBtn) => closeBtn.addEventListener('click', close.bind(closeBtn)));
};

const initMenuClicks = () => {
    const menuLinks = [...document.querySelectorAll('.menu__link')];
    const toggle = document.querySelector('#toggle');

    menuLinks.forEach((link) => {
        if (link.classList.contains('accordion-item')) return;
        link.addEventListener('click', () => {
            if (!toggle) return;
            toggle.checked = false;
        });
    });
};

const checkCookieWarning = () => {
    if (!localStorage.getItem('cookieWarn')) {
        document.querySelector('.cookie-warning').classList.add('show');
    }
};

const setCookieWarningOff = () => {
    localStorage.setItem('cookieWarn', true);
    document.querySelector('.cookie-warning').classList.remove('show');
};

const initCookieWarning = () => {
    checkCookieWarning();

    document
        .querySelector('.cookie-warning__ok-button')
        .addEventListener('click', () => {
            setCookieWarningOff();
        });
};

const initAccordion = () => {
    const accordionHTPBlocks = [
        ...document.querySelectorAll('.how-to-play__content details')
    ];

    if (!accordionHTPBlocks.length) return;

    accordionHTPBlocks.forEach((block) => {
        block.addEventListener('click', () => {
            accordionHTPBlocks.forEach((accBlock) => {
                if (accBlock.dataset.index !== block.dataset.index) {
                    accBlock.open = false;
                    setTimeout(() => {
                        accBlock.open = false;
                    }, 700);
                }
            });
        });
    });
};
const initFrom = () => {
    const form = document.querySelector('#feedback');

    if (!form) return;

    form.onsubmit = async (e) => {
        e.preventDefault();

        const dialog = document.querySelector('#dialog');

        const response = await fetch('/feedback/', {
            method: 'POST',
            body: new FormData(form)
        });

        const result = await response.json();

        let notify;

        if (result.success) {
            notify = new Notify({
                status: 'success',
                title: 'Ваше сообщение отправлено',
                effect: 'fade',
                speed: 300,
                customClass: 'hi-z',
                // customIcon: null,
                // showIcon: true,
                // showCloseButton: true,
                autoclose: true,
                // autotimeout: 3000,
                // gap: 20,
                // distance: 20,
                type: 3,
                position: 'x-center bottom'
            });
        } else {
            notify = new Notify({
                status: 'error',
                title: 'Что то пошло не так',
                text: 'Мы не смогли отправить ваше сообщение',
                effect: 'fade',
                speed: 300,
                customClass: 'hi-z',
                // customIcon: null,
                // showIcon: true,
                // showCloseButton: true,
                autoclose: true,
                // autotimeout: 3000,
                // gap: 20,
                // distance: 20,
                type: 3,
                position: 'x-center bottom'
            });
        }

        dialog.close('Ok! 🤠');

        setTimeout(() => {
            notify.close();
        }, 3200);
    };
};

const setIosAppInfoDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        const mobCaption = document.getElementById('mob-app-caption');
        const mobButton = document.getElementById('mob-app-button');
        const mobAndroidLink = document.getElementById('android-apk-link');

        if (!mobCaption && !mobButton && !mobAndroidLink) return;

        mobCaption.innerText = 'Скачай приложение на IOS и подключайся к трансляции на ПК';
        mobButton.innerText = 'Скачать в App Store';
        mobButton.classList.remove('android-button');
        mobButton.href = 'https://apps.apple.com/us/app/mts-remote-play/id1627685267';
        mobButton.setAttribute('event-label', 'skachat_v_app_store');
        mobAndroidLink.remove();
    }
};

const registerServiceWorker = () => {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

    navigator.serviceWorker.register('/sw-v3.js', {
        scope: '/',
        updateViaCache: 'none'
    }).catch(() => {
        // The website remains available online if registration fails.
    });
};

window.addEventListener('load', () => {
    initRellax();
    initInView();
    checkHeaderPos();
    initModal();
    initMenuClicks();
    initCookieWarning();
    initAccordion();
    initFrom();
    setIosAppInfoDownload();
    registerServiceWorker();
});
